import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=42018222&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42018222')) {
      api.createRecord('42018222', component.options)
    } else {
      api.reload('42018222', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=42018222&", function () {
      api.rerender('42018222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Components/ForgotPassword/ForgotPassword.vue"
export default component.exports